import { OrdersBasketBody } from 'components/Workspaces/OrdersBasket/FormTable/Body/OrdersBasketBody';
import { OrdersBasketHeader } from 'components/Workspaces/OrdersBasket/FormTable/Header/OrdersBasketHeader';
import { OrdersBasketFormTableNext } from 'components/Workspaces/OrdersBasket/FormTable/OrdersBasketFormTableNext';
import { OrdersBasketInteractionToolbar } from 'components/Workspaces/OrdersBasket/OrdersBasketInteractionToolbar/OrdersBasketInteractionToolbar.connect';
import { OrdersBasketToolbarComponentNext } from 'components/Workspaces/OrdersBasket/Toolbar/OrdersBasketToolbarNext';
import { FC, memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'state/state.model';
import { getOrdersBasketWorkspaceTabContentById } from 'state/workspaces/ordersBasket/tabContent/tabContent.selectors';
import { getWorkspaceActiveTabId } from 'state/workspaces/workspaces/workspaces.selector';

interface OrdersBasketWorkspaceNextProps {
  isVisible: boolean;
}

export const OrdersBasketWorkspaceNext: FC<OrdersBasketWorkspaceNextProps> = memo(({ isVisible }) => {
  const activeTabId = useSelector((state: AppState) => getWorkspaceActiveTabId(state, 'ordersBasket'));
  const tabContent = useSelector((state: AppState) =>
    activeTabId ? getOrdersBasketWorkspaceTabContentById(state, activeTabId) : undefined,
  );

  const productVariation = useMemo(
    () => ({
      productSubType: tabContent?.productSubtype || '',
      productType: tabContent?.productType || '',
    }),
    [tabContent],
  );

  return (
    <div className="h-100 d-flex flex-column bg-lvl1">
      <OrdersBasketToolbarComponentNext
        className="p-2"
        productSubType={productVariation.productSubType}
        productType={productVariation.productType}
      />
      <OrdersBasketFormTableNext
        className="flex-grow-1 px-2 pb-2"
        productType={productVariation.productType}
        productSubType={productVariation.productSubType}
      >
        <OrdersBasketHeader
          productSubType={productVariation.productSubType}
          productType={productVariation.productType}
        />
        <OrdersBasketBody
          productSubType={productVariation.productSubType}
          productType={productVariation.productType}
          isVisible={isVisible}
        />
      </OrdersBasketFormTableNext>
      <OrdersBasketInteractionToolbar
        productSubType={productVariation.productSubType}
        productType={productVariation.productType}
      />
    </div>
  );
});
